import { routeFactory } from "@/RouteFactory";
import { Tab } from "@/components/tabs/Tab";
import { testIdConstants } from "@/types/test-id-constants/testIdConstants";
import { TabMenu } from "@stenajs-webui/elements";
import * as React from "react";

interface Props {
  customerNo: string;
}

export const AgreementDocumentsTabMenu: React.FC<Props> = ({ customerNo }) => {
  const agreementDocumentsPath =
    routeFactory.productAndPrice.headAgreement.agreementDocuments({
      customerNo,
    });
  const rebateAgreementDocumentsPath =
    routeFactory.productAndPrice.headAgreement.rebateAgreementDocuments({
      customerNo,
    });
  return (
    <div data-testid={testIdConstants.documentsViewTabs}>
      <TabMenu>
        <Tab label={"Agreements"} path={agreementDocumentsPath} />
        <Tab label={"Rebate"} path={rebateAgreementDocumentsPath} />
      </TabMenu>
    </div>
  );
};
